import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Download, AlertTriangle } from "lucide-react";
import { useAuth } from "../lib/auth";
import { DocumentUploadModal, DOC_TYPES } from "../components/DocumentUploadModal";

import { tr, lbl, trText } from "../lib/i18n";
export default function DocumentsPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState(""); const [type, setType] = useState("");
  const [error, setError] = useState(null);
  const { can } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let alive = true;
    (async () => {
      setError(null);
      try {
        const { data } = await api.get("/documents", { params: { q, doc_type: type } });
        if (alive) setItems(data.items || []);
      } catch (e) {
        if (alive) { setError(formatApiError(e)); setItems([]); }
      }
    })();
    return () => { alive = false; };
  }, [q, type, reload]);

  return (
    <div className="space-y-5" data-testid="documents-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div><div className="eyebrow">{tr("x.files")}</div><h1 className="text-3xl font-semibold" style={{ fontFamily: "Outfit" }}>{tr("x.documents")}</h1></div>
        {can("vehicles", "edit") && <button className="btn-primary" onClick={() => setUploading(true)} data-testid="documents-upload-btn">{tr("x.upload_document")}</button>}
      </div>
      {uploading && <DocumentUploadModal onClose={() => setUploading(false)} onSaved={() => { setUploading(false); setReload((n) => n + 1); }} />}
      {error && (
        <div className="panel p-4 flex items-start gap-3 border-l-4 border-red-500" data-testid="documents-error">
          <AlertTriangle size={18} className="text-red-500 mt-0.5" />
          <div>
            <div className="font-semibold text-sm">{tr("x.could_not_load_documents")}</div>
            <div className="text-xs text-[var(--gray-400)] mt-0.5">{error}</div>
          </div>
        </div>
      )}
      <div className="panel p-3 flex gap-2 flex-wrap">
        <input placeholder={tr("x.search_name_or_vehicle")} value={q} onChange={(e) => setQ(e.target.value)} className="h-9 rounded-lg border border-[hsl(var(--border))] px-3 text-sm flex-1 min-w-[240px]" />
        <select value={type} onChange={(e) => setType(e.target.value)} className="h-9 rounded-lg border border-[hsl(var(--border))] px-3 text-sm">
          <option value="">{tr("x.all_types")}</option>
          {DOC_TYPES.map((t) => <option key={t} value={t}>{lbl(t)}</option>)}
          <option value="form_authorization">{tr("x.sale_authorization")}</option>
          <option value="form_inspection">{tr("x.inspection_release")}</option>
          <option value="form_testdrive">{tr("x.test_drive")}</option>
        </select>
      </div>
      <div className="panel overflow-x-auto">
        <table className="w-full dense-table">
          <thead><tr><th>{tr("x.name")}</th><th>{tr("x.type")}</th><th>{tr("x.linked")}</th><th>{tr("x.uploaded_2")}</th><th>{tr("x.expiry")}</th><th></th></tr></thead>
          <tbody>
            {items.map((d) => (
              <tr key={d.id}>
                <td className="font-semibold"><bdi>{trText(d.name)}</bdi></td>
                <td className="text-xs">{lbl(d.doc_type) || "—"}</td>
                <td className="text-xs">{d.linked_entity_label || "—"}</td>
                <td className="text-xs whitespace-nowrap"><bdi>{(d.uploaded_at || "").slice(0, 10)}</bdi></td>
                <td className="text-xs whitespace-nowrap"><bdi>{d.expiry_date || "—"}</bdi></td>
                <td><a href={d.url} target="_blank" rel="noreferrer" className="text-accent-brand text-xs font-semibold flex items-center gap-1"><Download size={12} /> {tr("x.open")}</a></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-[var(--gray-400)]">{tr("x.no_documents")}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
